<template>
  <div id="app">
    <b-navbar variant="faded" type="light">
      <div class="container">
        <b-navbar-brand href="/">
          <img alt="Vue logo" src="./assets/logo.png">
        </b-navbar-brand>
      </div>
    </b-navbar>

    <div class="container">
      <b-overlay :show="isCardLoading" rounded="sm">
        <b-card class="pt-2 mt-2" v-if="search">
          <p class="fs-5">Telefon numaranız ile borç sorgulayabilir, isterseniz kolayca ödeme yapabilirsiniz</p>
          <b-form-input v-model="mobile" placeholder="Telefon Numaranız"></b-form-input>
          <b-button block class="mt-2" variant="primary" @click="searchCustomer()">Borç Sorgula</b-button>
          <b-row>
            <b-col style="padding-right:5px">
              <b-button block class="mt-2" variant="info" @click="bankModal=true">EFT/Havale İle Ödeme</b-button>
            </b-col>
            <b-col style="padding-left:5px">
              <b-button block class="mt-2" variant="info" @click="preparePay([])">Kredi Kartı İle Ödeme</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="pt-2 mt-2" v-if="list" title="İlişkili Hesaplar">
        <div v-for="contact in listData" v-bind:key="contact.contact_id" class="p-3">
          <b-row class="balance-info mb-2">
            <b-col>
              <div class="text-left">
                {{contact.name}}
              </div>
            </b-col>
            <b-col>
              <div class="text-right">
                {{contact.contact_due}} TL
              </div>
            </b-col>
          </b-row>
            <b-dropdown block id="dropdown-1" variant="primary" text="Ödeme Seçenekleri" class="m-md-2">
              <b-dropdown-item @click="bankModal=true">EFT/Havale</b-dropdown-item>
              <b-dropdown-item @click="preparePay(contact.name_info,contact.mobile)">Kredi Kartı</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="text-right">
        <small style="color:gray">(+) Değerlerde müşteri borçlu, (-) değerlerde müşteri alacaklıdır.</small>
        </div>
      </b-card>

    <b-card class="pt-2 mt-2" v-if="payment" title="Ödeme">
      <form>
      <b-row>
        <b-col>
          <div class="payment-info">
            <b-row>
              <b-col>
              <b-form-group label="Ad" label-for="input-name">
                <b-form-input
                  placeholder="Ad"
                  id="input-name"
                  name="first_name"
                  v-model="customer.first_name"
                >
                </b-form-input>
              </b-form-group>
              </b-col>
              <b-col>
              <b-form-group label="Soyad" label-for="input-surname">
                <b-form-input
                  placeholder="Soyad"
                  id="input-surname"
                  name="last_name"
                  v-model="customer.last_name"
                >
                </b-form-input>
              </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="Telefon Numarası" label-for="input-mobile">
              <b-form-input
                placeholder="Telefon Numarası"
                id="input-mobile"
                v-model="customer.phone"
                name="phone"
              >
              </b-form-input>
            </b-form-group>
              <b-form-group label="Tutar" label-for="input-amount">
                <b-form-input
                  placeholder="Tutar"
                  id="input-amount"
                  v-model="amount"
                  name="amount" 
                  required
                >
                </b-form-input>
            </b-form-group>
          </div>
        </b-col>

        <b-col>
        <div class="row">
          <div class="form-group col-sm-12">
              <label for="name">Kart Üzerindeki Ad Soyad</label>
              <input type="text" v-model="card.cc_owner" name="cc_owner" id="name" class="form-control" placeholder="Kart Üzerindeki Ad Soyad" required>
          </div>

          <div class="form-group col-sm-12">
              <label for="number">Kart Numarası</label>
              <input type="text" name="cc_number" v-model="card.cc_number" id="number" class="form-control" placeholder="Kart Numarası" required>
          </div>
                  
          <div class="form-group col-sm-6">
            <label>Son Kul. Tarihi</label>
            <b-row>
              <b-col>
                <select v-model="card.exp_month" name="exp_month" id="month" class="form-control" required>
                    <option value="">Ay</option>
                    <option v-for="month in 12" v-bind:key="month" :value="month">{{month}}</option>
                </select>
              </b-col>

              <b-col>
                <select v-model="card.exp_year" name="exp_year" id="year" class="form-control" required>
                    <option value="">Yıl</option>
                    <option v-for="year in years" v-bind:key="year" :value="year">{{ year }}</option>
                </select>
              </b-col>
            </b-row>
          </div>

          <div class="form-group col-sm-6">
              <label for="cvv">CVV</label>
              <input type="text" v-model="card.cc_cvv" name="cc_cvv" id="cvv" class="form-control" placeholder="CVV" required>
          </div>
        </div>
        </b-col>
      </b-row>

      <b-table-simple responsive v-if="lastAmount!==null && !isNaN(lastAmount)" id="payment-info-table">
      <b-tbody>
        <b-tr>
          <b-td><img width="100" :src="'/img/esnekpos_payment/'+cardFamily+'.svg'" v-if="cardFamily!==null && cardFamily!=='yurtdisi'"></b-td>
          <b-td>Taksit Sayısı: {{card.installment_number}}</b-td>
          <b-td>Tahsil Edilecek Tutar: {{lastAmount | turkishMoney}}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>

      <b-button block variant="primary" id="submit-button" @click="submitPayment()">Ödemeyi Onayla</b-button>

      <div id="installments" v-if="installments.axess.length>0 && amount!=''">
        <table style="width: 100%;" class="esnekpos-rates-table">
          <tbody>
          <tr class="esnekpos-rates-table-with-bg" style="height:50px;">
            <th>Taksit</th>
            <th class="esnekpos-rates-table-with-bg">   
              <img src="./assets/esnekpos_payment/axess.svg">
            </th>
            <th class="esnekpos-rates-table-with-bg">   
              <img src="./assets/esnekpos_payment/world.svg">
            </th> 
            <th class="esnekpos-rates-table-with-bg">   
              <img src="./assets/esnekpos_payment/bonus.svg">
            </th>
            <th class="esnekpos-rates-table-with-bg">   
              <img src="./assets/esnekpos_payment/cardfinans.svg">
            </th>
            <th class="esnekpos-rates-table-with-bg">   
              <img src="./assets/esnekpos_payment/maximum.svg">
            </th>
            <th class="esnekpos-rates-table-with-bg">   
              <img src="./assets/esnekpos_payment/paraf.svg">
            </th>
            <th class="esnekpos-rates-table-with-bg">   
              <img src="./assets/esnekpos_payment/combo.svg">
            </th>
          </tr>
          
          <tr v-for="item in 6" :key="item" :id="'installment-'+item">
            <td>
              <input type="radio" :id="'installment'+item" :name="'installment'+item" v-model="card.installment_number" :value="item">
                <label :for="'installment'+item">&nbsp;{{item}}</label>
            </td>
            <td name="axess">
              <span :data-amount="parseFloat(amount)+parseFloat(amount*installments.axess[item-1]['RATE'])">
                {{parseFloat(amount)+parseFloat(amount*installments.axess[item-1]['RATE']) | turkishMoney }} 
              </span>
            </td>
            <td name="world">
              <span :data-amount="parseFloat(amount)+parseFloat(amount*installments.world[item-1]['RATE'])">
                {{parseFloat(amount)+parseFloat(amount*installments.world[item-1]['RATE']) | turkishMoney }} 
              </span>
            </td>
            <td name="bonus">
              <span :data-amount="parseFloat(amount)+parseFloat(amount*installments.bonus[item-1]['RATE'])">
                {{parseFloat(amount)+parseFloat(amount*installments.bonus[item-1]['RATE']) | turkishMoney }} 
              </span>
            </td>
            <td name="cardfinans">
              <span :data-amount="parseFloat(amount)+parseFloat(amount*installments.cardfinans[item-1]['RATE'])">
                {{parseFloat(amount)+parseFloat(amount*installments.cardfinans[item-1]['RATE']) | turkishMoney }} 
              </span>
            </td>
            <td name="maximum">
              <span :data-amount="parseFloat(amount)+parseFloat(amount*installments.maximum[item-1]['RATE'])">
                {{parseFloat(amount)+parseFloat(amount*installments.maximum[item-1]['RATE']) | turkishMoney }} 
              </span>
            </td>
            <td name="paraf">
              <span :data-amount="parseFloat(amount)+parseFloat(amount*installments.paraf[item-1]['RATE'])">
                {{parseFloat(amount)+parseFloat(amount*installments.paraf[item-1]['RATE']) | turkishMoney }} 
              </span>
            </td>
            <td name="combo">
              <span :data-amount="parseFloat(amount)+parseFloat(amount*installments.combo[item-1]['RATE'])">
                {{parseFloat(amount)+parseFloat(amount*installments.combo[item-1]['RATE']) | turkishMoney }} 
              </span>
            </td>
          </tr>
        </tbody>
       </table>
      </div>
      </form>
    </b-card>
  </b-overlay>
      <div class="footer-wrapper">
        <img alt="Vue logo" src="./assets/3d.png">
      </div>
    </div>

      <b-modal id="modal-1" title="EFT/Havale Bilgileri" v-model="bankModal" hide-footer>
        <p class="my-3 text-center">
          IBAN <br/>
          Emrullah Serdar KAYA <br/>
          TR26 0011 1000 0000 0081 1359 81
        </p>
      </b-modal>

  </div>
</template>
<script>
const axios = require('axios').default;

export default {
  name: 'app',
  data() {
    return {
      lastAmount: null,
      cardFamily: null,
      bankModal: false,
      installments: {
        axess: [],
        world: [],
        cardfinans: [],
        maximum: [],
        combo: [],
        bonus: [],
        paraf: [],
        null: [],
        yurtdisi: []
      },
      mobile: "",
      search: 1,
      list: 0,
      payment: 0,
      listData : [],
      selectedContact: null,
      years: [],
      amount: "",
      installment: 1,
      isCardLoading: 0,
      card: {
        cc_number: "",
        exp_month: "",
        exp_year: "",
        cc_cvv: "",
        cc_owner: "",
        installment_number: 1,
      },
      customer: {
        first_name: "",
        last_name: "",
        phone: "",
      }
    }
  },
  created() {
    document.title = "Eaasis Ödeme";
  },
  mounted() {
    this.setYears();
  },
  watch: {
    amount: function() {
        this.getInstallments();
    },
    'card.installment_number': function(val, oldVal) {
      if(this.lastAmount!==null && this.amount!=="") {
        this.calculateLastAmount();
      }
    },
    'card.cc_number': function(val, oldVal) {
      if(val.replace(/\s/g, '').length>=8) {
        this.getBin();
      }
    }
  },
  methods: {
    calculateLastAmount() {
      if(this.cardFamily==null) {
        this.lastAmount = parseFloat(this.amount)+parseFloat(this.amount*this.installments.null['RATE']);
      } else if(this.cardFamily=="yurtdisi") {
        this.lastAmount = parseFloat(this.amount)+parseFloat(this.amount*this.installments.yurtdisi['RATE']);
      } else {
        this.lastAmount = document.querySelector('tr#installment-'+this.card.installment_number+'> td[name="'+ this.cardFamily +'"] span').getAttribute("data-amount");
      }
    },
    getBin() {
      axios.get('/service/pay.php', {
        params : {
          action: 'bin',
          CardNumber: this.card.cc_number.replace(/\s/g, '')
        }
      })
        .then((response) =>  {

      if(this.cardFamily==null) {
        this.lastAmount = parseFloat(this.amount)+parseFloat(this.amount*this.installments.null['RATE']);
        console.log(this.lastAmount);
      } else if(this.cardFamily=="yurtdisi") {
        this.lastAmount = parseFloat(this.amount)+parseFloat(this.amount*this.installments.yurtdisi['RATE']);
      } else {
        this.lastAmount = document.querySelector('tr#installment-'+this.card.installment_number+'> td[name="'+ this.cardFamily +'"] span').getAttribute("data-amount");
      }

          if(response.data['Card_Family']) {
            this.cardFamily = response.data['Card_Family'].toLowerCase();
            console.log(this.cardFamily);
            if(this.amount !== "" && this.card.installment_number) {
                    if(this.cardFamily==null) {
                      this.lastAmount = parseFloat(this.amount)+parseFloat(this.amount*this.installments.null['RATE']);
                      console.log(this.lastAmount);
                    } else if(this.cardFamily=="yurtdisi") {
                      this.lastAmount = parseFloat(this.amount)+parseFloat(this.amount*this.installments.yurtdisi['RATE']);
                    } else {
                      this.lastAmount = document.querySelector('tr#installment-'+this.card.installment_number+'> td[name="'+ this.cardFamily +'"] span').getAttribute("data-amount");
                    }
              this.lastAmount = document.querySelector('tr#installment-'+this.card.installment_number+'> td[name="'+ this.cardFamily +'"] span').getAttribute("data-amount");
            }
          }
        }) ;
    },
    submitPayment() {
      this.isCardLoading = 1;

      var form = new FormData();
      form.append('action',  'payment');
      form.append('cc_number',  this.card.cc_number);
      form.append('exp_month',  this.card.exp_month);
      form.append('exp_year',  this.card.exp_year);
      form.append('cc_cvv',  this.card.cc_cvv);
      form.append('cc_owner',  this.card.cc_owner);
      form.append('installment_number',  this.card.installment_number);
      form.append('first_name', this.customer.first_name);
      form.append('last_name', this.customer.last_name);
      form.append('phone', this.customer.phone);
      form.append('amount', this.amount)
      form.append('pos_amount', (this.lastAmount!==null) ? this.lastAmount : this.amount);

      axios({
        method: "POST",
        url: "/service/pay.php",
        data: form,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) =>  {
          if(response.data['STATUS'] == 'SUCCESS') {
             window.location.href = response.data['URL_3DS'];
          } else if(response.data['STATUS']!=='SUCCESS') {
            this.$bvToast.toast(response.data['RETURN_MESSAGE'], {
              title: `Eaasis`,
              toaster: 'b-toaster-top-center',
              variant: 'danger',
              solid: true,
              appendToast: false
            });
            this.isCardLoading = 0;
          }
        })
        .catch((response) => {
          //handle error
        });
    },
    setYears() {
      let years = [];
      for (var i = new Date().getFullYear(); i <= new Date().getFullYear()+10; i++) {
        years.push(i);
      }
      this.years = years;
    },
    searchCustomer() {
      this.isCardLoading = 1;
      axios.get('/service/index.php', {
        params : {
          action: 'customer',
          mobile: this.mobile
        }
      })
      .then((response) => {
        if(response.data.message) {
          this.$bvToast.toast(response.data.message, {
            title: `Eaasis`,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true,
            appendToast: false
          });
        } else {
            this.search = 0;
            this.list = 1;
            this.listData = response.data;
        }
        this.isCardLoading = 0;
      });
    },
    getInstallments() {
      this.installments = {
        axess: [],
        world: [],
        cardfinans: [],
        maximum: [],
        combo: [],
        bonus: [],
        paraf: [],
        null: [],
        yurtdisi: [],
      }
      axios.get('/service/pay.php', {
        params : {
          action: 'installment',
        }
      })
      .then((response) => {
        if(response.data['STATUS']=="SUCCESS") {
          response.data['INSTALLMENTS'].forEach(installment => {
              if(installment['FAMILY']==null) {
                this.installments.null = installment;
              }else if(installment['FAMILY']=='yurtdisi') {
                this.installments.yurtdisi = installment;
              }else if(installment['FAMILY']=='axess') {
                this.installments.axess = [...this.installments.axess, installment];
              }else if(installment['FAMILY']=='world') {
                this.installments.world = [...this.installments.world, installment];
              }else if(installment['FAMILY']=='bonus') {
                  this.installments.bonus = [...this.installments.bonus, installment];
              }else if(installment['FAMILY']=='cardfinans') {
                  this.installments.cardfinans = [...this.installments.cardfinans, installment];
              }else if(installment['FAMILY']=='maximum') {
                  this.installments.maximum = [...this.installments.maximum, installment];
              }else if(installment['FAMILY']=='paraf') {
                  this.installments.paraf = [...this.installments.paraf, installment];
              }else if(installment['FAMILY']=='combo') {
                  this.installments.combo = [...this.installments.combo, installment];
              }
          });
        }
      })
      .then(() => {
          this.calculateLastAmount();
      });
    },
    preparePay(name_info,phone) {
      this.customer.first_name = name_info.first_name;
      this.customer.last_name = name_info.last_name;
      this.customer.phone = phone;
      this.list = 0;
      this.search = 0;
      this.payment = 1;  
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap');
#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f8faff;
}

@media (min-width: 1200px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl {
      max-width: 1040px;
  }
}
html {
  background: #f8faff;
}

.card {
  border: none!important;
  box-shadow: 0px 0px 10px 0px rgb(0 0 0 / 8%);
}

.btn-primary {
  background-color: #001a57!important;
  color:#FFF;
  border-color: #001a57!important;
}
 
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open .dropdown-toggle.btn-primary {
  background-color: #000f32!important;
  color:#FFF;
  border-color: #000f32!important;
}

.balance-info {
    border: 1px solid #dedede;
    padding: 0.5rem;
    border-radius: 0.25rem;
    margin: 0;
}

.payment-info {
    border-radius: 0.25rem;
    margin: 0;
}

.footer-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.footer-wrapper img {
    width: 110px;
}

.esnekpos-rates-table {      margin-top: 1rem; border-spacing: 0;      border-collapse: collapse;      width: 100%;   }
.esnekpos-rates-table-with-bg img{      width: 64px;   } 
.esnekpos-rates-table-with-bg {      color: #111;      background: #f8f8f8;      border: 1px solid #e3e3e3;   } 
.esnekpos-rates-table td.axess{    background-color:#e2b631;    color:#fff;   }
.esnekpos-rates-table td.maximum{       background-color:#f52295;       color:#fff;   } 
.esnekpos-rates-table td.cardfinans{       background-color: #2d5fc2;       color:#fff;   }
.esnekpos-rates-table td.world{       background-color: #6f6b99;       color:#fff;   } 
.esnekpos-rates-table td.bonus{       background-color: #479279;       color:#fff;   }
.esnekpos-rates-table td{      padding: 5px 10px;      text-align: center;   } 
.esnekpos-amount {      font-size: 13px;      font-weight: 700;      line-height: 20px;   }
.esnekpos-rates-table td span {      display: inline-block;      width: 100%;      text-align: center;   } 
.esnekpos-rates-table 
.esnekpos-total-amount {      font-size: 11px;      font-weight: 400;      line-height: 20px;   } 
.esnekpos-rates-table td {      border: 1px dashed #d6d6d6;   } 
.esnekpos-rates-table-with-bg {      font-size: 13px!important;   }

#installments {
  overflow-x: scroll;
}

#payment-info-table td {
  vertical-align: unset!important;
}

#payment-info-table {
  border: 1px solid #dee2e6;
}
</style>
